import { useNavigate } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbButton,
  BreadcrumbDivider,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { HomeRegular } from '@fluentui/react-icons';
import { realLinkProps } from '../links/realLinkProps';

export interface BreadcrumbItemConfig {
  label: string;
  href?: string;
  icon?: React.ReactElement;
}

export interface PageBreadcrumbProps {
  items: BreadcrumbItemConfig[];
}

const useStyles = makeStyles({
  root: {
    marginBottom: tokens.spacingVerticalM,
  },
  currentItem: {
    fontWeight: tokens.fontWeightSemibold,
  },
});

export default function PageBreadcrumb({ items }: PageBreadcrumbProps) {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <Breadcrumb aria-label="Breadcrumb navigation" className={styles.root}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isFirst = index === 0;
        const icon = isFirst ? <HomeRegular /> : item.icon || undefined;

        return (
          <span key={item.label}>
            <BreadcrumbItem>
              {/* Real links (fleet ruling 2026-10-29): the current page is not a link, so only a
                  non-last item with a destination renders as one. */}
              {!isLast && item.href ? (
                <BreadcrumbButton
                  as="a"
                  current={false}
                  icon={icon}
                  {...realLinkProps(item.href, { navigate })}
                >
                  {item.label}
                </BreadcrumbButton>
              ) : (
                <BreadcrumbButton
                  current={isLast}
                  icon={icon}
                  className={isLast ? styles.currentItem : undefined}
                >
                  {item.label}
                </BreadcrumbButton>
              )}
            </BreadcrumbItem>
            {!isLast && <BreadcrumbDivider />}
          </span>
        );
      })}
    </Breadcrumb>
  );
}
